import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useIsUSInfluencer } from '../hooks/useIsUSInfluencer';
import { infPaths } from '../modules/influencer/routes';
import { isTalentPartner, usesInfluencerFlow } from '../modules/influencer/flowUser';

// Landing page for a bare "/influencer" visit: FOREIGN influencers go straight to
// Zap, everyone else to the Dashboard. Foreignness comes from the reliable
// dialing_code (sync), so no waiting/flash. The ZapOnlyGuard enforces this on
// every sub-route too, so even a direct /influencer/dashboard URL is corrected.
export const InfluencerIndexRedirect: React.FC = () => {
    const isForeign = useIsUSInfluencer();
    return <Navigate to={isForeign ? '/influencer/zap' : 'dashboard'} replace />;
};

// /influencer/dashboard — where every older page and email sends an influencer
// home. Influencers, and Talent Partners inside a picked creator, now land on
// the new campaign flow's Home (as brands do on theirs). A Talent Partner with
// no creator picked goes to /switch/user to pick one (OLD: the old dashboard,
// which listed the retired legacy campaigns). (Foreign influencers are sent to
// Zap by the ZapOnlyGuard.)
export const InfluencerDashboardEntry: React.FC<{ legacy: React.ReactElement }> = ({ legacy }) => {
    const user = useSelector((state: any) => state.UserReducer?.UserData);
    const owner = useSelector((state: any) => state.SwitchLayer2Reducer?.switchUser);
    if (usesInfluencerFlow(user, owner)) return <Navigate to={infPaths.home()} replace />;
    if (isTalentPartner(user)) return <Navigate to='/switch/user' replace />;
    return legacy;
};
